import PropTypes from 'prop-types';
import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { catalogBibShape } from '@bibliocommons/bc-prop-types';
import DeleteUgcForm from 'app/components/bibs/shared/ugc/DeleteUgcForm';
import ModalContainer from 'app/components/shared/Modal/ModalContainer';

export default function DeleteAgeRatingModal({
  ageSuitabilityId,
  catalogBib,
  ageSuitabilitiesActions,
  handleSuccess,
  modalActions,
  ageSuitabilitiesTransactions
}) {
  function handleClose() {
    modalActions.closeModal(`delete-age-rating-${ageSuitabilityId}`);
  }

  return (
    <ModalContainer
      className="cp-delete-age-rating-modal"
      dataKey="delete-age-rating-modal"
      modalKey={`delete-age-rating-${ageSuitabilityId}`}
      size="small"
      handleClose={handleClose}
    >
      <DeleteUgcForm
        ugcType="ageSuitability"
        id={ageSuitabilityId}
        catalogBib={catalogBib}
        removeUgcAction={ageSuitabilitiesActions.removeAgeSuitability}
        transactions={ageSuitabilitiesTransactions}
        handleClose={handleClose}
        handleSuccess={handleSuccess}
      />
    </ModalContainer>
  );
}

DeleteAgeRatingModal.propTypes = {
  ageSuitabilityId: PropTypes.number.isRequired,
  catalogBib: catalogBibShape.isRequired,
  handleSuccess: PropTypes.func,
  ageSuitabilitiesActions: PropTypes.objectOf(PropTypes.func).isRequired,
  ageSuitabilitiesTransactions: ImmutablePropTypes.map.isRequired,
  modalActions: PropTypes.objectOf(PropTypes.func).isRequired
};
